import { Card, CardBody } from '@components/card/card';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useState } from 'react';
// import TakeOver from './TakeOver';
import { useTranslation } from 'react-i18next';
import useGetEquipmentsList from '@hooks/FLeet/useGetEquipmentsList';
import Loading from '@components/Shared/Loader/Loading';
// import NtxTable from '@components/DataTable/NtxTable';
// import NtxCustomModal from '@components/Modal/NtxCustomModal';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { Form, Row, Col, Badge, Button, ButtonGroup } from 'react-bootstrap';
import Pagination from '@components/Shared/Pagination/Pagination';
import { useNavigate } from 'react-router-dom';

const CardTakeOver = () => {
  const { HasPermission } = usePermissions();
  const navigate = useNavigate();

  // const [show, setShow] = useState(false);
  // const [data, setData] = useState<any>({ id: null, equipmentsAssignationId: null, equipmentsAssignationDate: null });
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(8);

  const { t, i18n } = useTranslation();
  const { EquipmentsList, loading, error } = useGetEquipmentsList();

  // Filter equipment - only show vehicles with drivers and apply search/filters
  const filteredEquipments = EquipmentsList?.filter(
    item =>
      item.peopleName &&
      (item.plateNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.modelName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.modelName2?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.peopleNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.peopleName2?.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (statusFilter === 'all' || item.status === statusFilter)
  );

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredEquipments?.slice(indexOfFirstData, indexOfLastData);

  const formatDate = (dateString: string | number | Date) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  return (
    <>
      <div className='d-flex align-items-center  '>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Takeover',
              link: null
            }
          ]}
          PageName='Takeover'
        />
      </div>

      {/* Search and Filter Section */}
      <Card className='mb-4'>
        <CardBody>
          <Row>
            <Col md={8}>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fa fa-search text-theme me-2'></i>
                  {t('Search')}
                </span>
                <input
                  type='search'
                  autoComplete='off'
                  className='form-control'
                  placeholder={t('Search')}
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
            </Col>

            <Col md={4}>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='bi bi-funnel'></i>
                </span>
                <Form.Select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                  <option value='all'>{t('All')}</option>
                  <option value='Active'>{t('isActive')}</option>
                  <option value='Inactive'>{t('InActive')}</option>
                </Form.Select>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Loading loading={loading} error={error}>
        <Row>
          {currentData?.map(item => (
            <Col md={6} lg={4} xl={3} key={item.id} className='mb-4'>
              <Card className='h-100  takeover-card'>
                <div className='vehicle-image-container position-relative'>
                  {item.image === null ? (
                    // عرض أيقونة المركبة مع خلفية شفافة حمراء
                    <div className='vehicle-icon-container'>
                      <i className='bi bi-car-front-fill vehicle-icon'></i>
                    </div>
                  ) : (
                    <img alt={item.plateNo} className='vehicle-image' src={item?.image?.filePath} />
                  )}

                  <Badge
                    bg={item.status === 'Active' ? 'success' : item.status === 'Inactive' ? 'warning' : 'secondary'}
                    className='vehicle-status-badge'
                  >
                    <i
                      className={`bi  ${
                        item.status === 'Active'
                          ? 'bi-check-circle-fill'
                          : item.status === 'Inactive'
                          ? 'bi-exclamation-triangle-fill'
                          : 'bi-question-circle-fill'
                      } me-1`}
                    ></i>
                    {item.status === 'Active'
                      ? t('isActive')
                      : item.status === 'Inactive'
                      ? t('InActive')
                      : t('Unknown')}
                  </Badge>
                </div>
                <CardBody className='d-flex flex-column'>
                  <h6 className='mb-1 text-truncate text-success fw-bold'>
                    <i className='bi bi-upc-scan me-2 fa-lg'></i>
                    {item.plateNo}
                  </h6>
                  <p className='text-muted mb-1 text-truncate'>
                    <i className='bi bi-tag me-2 fa-lg'></i>
                    {i18n.language === 'en' ? item.modelName : item.modelName2}
                  </p>
                  <p className='text-muted mb-1 text-truncate'>
                    <i className='bi bi-person-circle me-2 fa-lg '></i>
                    <small className=''>
                      {i18n.language === 'en' ? item.peopleName : item.peopleName2 || t('NotAvailable')}
                    </small>
                  </p>
                  <p className='text-muted mb-1 text-truncate'>
                    <i className='bi bi-person-badge me-2 fa-lg'></i>
                    <small className=''>{item.peopleNumber || t('NotAvailable')}</small>
                  </p>

                  <p className='text-muted mb-3 text-truncate'>
                    <i className='bi bi-calendar-event me-2  fa-lg'></i>
                    {/* <span className='  me-2'>{t('Handover Date')} :</span> */}
                    {/* <small className=''>{item.equipmentsAssignationDate}</small> */}
                    <small className=''>{formatDate(item.equipmentsAssignationDate)}</small>
                  </p>

                  <div className='mt-auto'>
                    <Button
                      hidden={!HasPermission('FleetAddHandover')}
                      variant='danger'
                      className='w-100'
                      onClick={() => {
                        // setData({
                        //   id: item.id,
                        //   equipmentsAssignationId: item.equipmentsAssignationId,
                        //   equipmentsAssignationDate: item.equipmentsAssignationDate
                        // });
                        // setShow(true);
                        navigate(`${item.id}/TakeOverForm`);
                      }}
                    >
                      <i className='bi bi-arrow-right-circle me-1'></i>
                      {t('Takeover')}
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}

          {filteredEquipments?.length === 0 && !loading && (
            <Col className='text-center py-5'>
              <i className='bi bi-car-front' style={{ fontSize: '3rem', color: '#6c757d' }}></i>
              <p className='mt-3 text-muted'>{t('NoVehiclesAvailable')}</p>
              {/* <small className='text-muted'>{t('AllVehiclesHaveDrivers')}</small> */}
            </Col>
          )}
        </Row>

        <Pagination
          filteredData={filteredEquipments}
          dataPerPage={dataPerPage}
          handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
          currentPage={currentPage}
        />
      </Loading>

      {/* <NtxCustomModal show={show} setShow={setShow} width='94%' title={t('Takeover')}>
        {data.id && (
          <TakeOver
            Id={data.id}
            equipmentsAssignationDate={data.equipmentsAssignationDate}
            equipmentsAssignationId={data.equipmentsAssignationId}
            onclose={() => setShow(false)}
          />
        )}
      </NtxCustomModal> */}

      <style>
        {`

         
        .takeover-card {
          transition: transform 0.4s ease, box-shadow 0.2s ease;
          border-top: 3px solid #198754;
          border-color :  #198754;
        }

        .takeover-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 4px 15px rgba(220, 53, 69, 0.1);
        }

        .vehicle-image-container {
          position: relative;
          height: 150px;
          overflow: hidden;
          background-color: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
        }
          
        .vehicle-icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          background-color: rgba(23, 178, 93, 0.15); /* خلفية شفافة حمراء */
        }

        .vehicle-icon {
          font-size: 4rem;
          color: #198754; /* لون أحمر يتناسب مع التصميم */
        }

        .vehicle-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .vehicle-status-badge {
          position: absolute;
          top: 10px;
          right: 10px;
        }

        .availability-badge {
          position: absolute;
          top: 10px;
          left: 10px;
        }

        @media (max-width: 768px) {
          .vehicle-image-container {
            height: 150px;
          }
          
          .vehicle-icon {
            font-size: 3rem;
          }
        }

        .btn-danger {
          background-color: #198754;
          border-color: #198754;
        }
        
        .btn-danger:hover {
          background-color: #198754;
          border-color: #198754;
        }
        `}
      </style>
    </>
  );
};

export default CardTakeOver;
